import styled from "styled-components";

export const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  background-color: rgba(18, 18, 20, 0.5);
`;

export const StyledModal = styled.div`
  position: relative;
  border-radius: 4px;
  background-color: var(--color-gray-3);
  position: relative;

  header {
    background-color: var(--color-gray-2);
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
    padding: 1rem;
    border-radius: 4px 4px 0 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .iconButton {
    padding: 0;
    background-color: transparent;
    border: none;
    color: var(--color-gray-1);
    font-size: 16px;
    position: absolute;
    right: 12px;
    top: 12px;
  }

  svg {
  }

  Form {
    padding: 1.5rem;
    border-radius: 0 0 4px 4px;
  }

  section {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 5rem;
    padding: 1rem;
    gap: 2rem;
  }
`;
